document.addEventListener('alpine:init', () => {
    Alpine.data('sandwich', () => ({
        roofTiles: JSON.parse(document.getElementById('roof-tiles').textContent),
        thermalInsulations: JSON.parse(document.getElementById('thermal-insulations').textContent),

        iRoofChoices: [
            {name: 'iRoof Top', value: 'top', description: 'Tepelněizolační PIR desky Tondach Thermo nad krokvemi.'},
            {name: 'iRoof Uni', value: 'uni', description: 'Tepelněizolační desky Tondach Thermo nad krokvemi v kombinaci se zateplením mezi krokvemi.'},
            {name: 'iRoof Renova', value: 'renova', description: 'Tepelněizolační desky Tondach Thermo pod krokvemi v kombinaci se zateplením mezi krokvemi.'},
            {name: 'Vlastní', value: 'custom', description: 'Vlastní řešení zateplení střechy.'},
        ],

        minSlope: null,
        safeSlope: null,
        aboveLambda: null,
        innerLambda: null,
        belowLambda: null,

        init() {
            this.$watch('roofTile', () => {
                this.safeSlope = this.roofTiles.find(tile => tile.label === this.roofTile).safe_slope;
                this.minSlope = this.roofTiles.find(tile => tile.label === this.roofTile).min_slope;
            });
            this.$watch('aboveRoofInsulation', () => {
                let thickness = this.aboveRoofInsulationThickness;
                if (this.aboveRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.aboveRoofInsulation === '') {
                    this.aboveLambda = null;
                    return;
                }
                this.aboveLambda = this.thermalInsulations.find(i => i.label === this.aboveRoofInsulation)?.thickness_properties[thickness].thermal_conductivity_coefficient || null;
            });
            this.$watch('aboveRoofInsulationThickness', () => {
                let thickness = this.aboveRoofInsulationThickness;
                if (this.aboveRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.aboveRoofInsulation === '') {
                    this.innerLambda = null;
                    return;
                }
                this.aboveLambda = this.thermalInsulations.find(i => i.label === this.aboveRoofInsulation)?.thickness_properties[thickness].thermal_conductivity_coefficient || null;
            });
            this.$watch('innerRoofInsulation', () => {
                let thickness = this.crossSections.rafter.h;
                if (this.innerRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.innerRoofInsulation === '') {
                    this.innerLambda = null;
                    return;
                }
                this.innerLambda = this.thermalInsulations.find(i => i.label === this.innerRoofInsulation)?.thickness_properties[thickness].thermal_conductivity_coefficient || null;
            });
            this.$watch('crossSections.rafter.h', () => {
                let thickness = this.crossSections.rafter.h;
                if (this.innerRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.innerRoofInsulation === '') {
                    this.innerLambda = null;
                    return;
                }
                this.innerLambda = this.thermalInsulations.find(i => i.label === this.innerRoofInsulation)?.thickness_properties[thickness.rafter.h].thermal_conductivity_coefficient || null;
            });
            this.$watch('belowRoofInsulation', () => {
                let thickness = this.belowRoofInsulationThickness;
                if (this.belowRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.belowRoofInsulation === '') {
                    this.belowLambda = null;
                    return;
                }
                this.belowLambda = this.thermalInsulations.find(i => i.label === this.belowRoofInsulation)?.thickness_properties[thickness].thermal_conductivity_coefficient || null;
            });
            this.$watch('belowRoofInsulationThickness', () => {
                let thickness = this.belowRoofInsulationThickness;
                if (this.belowRoofInsulation === 'mineral-wool') {
                    thickness = '*';
                } else if (this.belowRoofInsulation === '') {
                    this.belowLambda = null;
                    return;
                }
                this.belowLambda = this.thermalInsulations.find(i => i.label === this.belowRoofInsulation)?.thickness_properties[thickness].thermal_conductivity_coefficient || null;
            });
            this.$watch('iRoofChoice', (choice) => {
                switch(choice) {
                    case 'top':
                        this.aboveRoofInsulation = 'comfort';
                        this.innerRoofInsulation = '';
                        this.belowRoofInsulation = '';
                        break;
                    case 'uni':
                        this.aboveRoofInsulation = 'comfort';
                        this.innerRoofInsulation = 'mineral-wool';
                        this.belowRoofInsulation = '';
                        break;
                    case 'renova':
                        this.aboveRoofInsulation = '';
                        this.innerRoofInsulation = 'mineral-wool';
                        this.belowRoofInsulation = 'classic';
                        break;
                    case 'custom':
                        this.aboveRoofInsulation = '';
                        this.innerRoofInsulation = '';
                        this.belowRoofInsulation = '';
                        break;
                }
            });
            this.$watch('roofType', (type) => {
                if (!(type === 'hambalkovy' || type === 'stredove-vaznice-klestina')) {
                    this.insulationType = 'to-the-ledge';
                }
            });
            this.$watch('iRoofChoice', (choice) => {
                if (!(choice === 'renova' || choice === 'custom')) {
                    this.insulationType = 'to-the-ledge';
                }
            });
        },
    }));
});